import parse from "html-react-parser";
import DOMPurify from "dompurify";
import Skeleton from "react-loading-skeleton";
import construnctionBackground from "../../../src/assest/home/construnction.jpg";
import person_back from "../../../src/assest/home/person_back.png";
import wall from "../../../src/assest/home/wall.webp";
import classes from "./Construction.module.css";

interface section3Props {
  pageData: {
    homePageData: {
      about_morasha: string;
    };
  };
  loading: boolean;
}
const Section3: React.FC<section3Props> = ({ pageData, loading }) => {
  let aboutText = (
    <Skeleton count={3} style={{ width: "300px", marginBottom: "10px" }} />
  );
  if (pageData) {
    const text = pageData.homePageData.about_morasha;
    const sanitizedHTML = DOMPurify.sanitize(text || ""); // Sanitize HTML content
    aboutText = <div>{parse(sanitizedHTML)}</div>;
  }

  return (
    <div
      className={classes.container + " " + classes.section3Container}
      style={{ backgroundImage: `url(${construnctionBackground})` }}
    >
      <div className={classes.innerContainer}>
        <div className={classes.aboutText + " " + classes.section3Text}>
          <h1>עולים קומה</h1>
          <h2>
            בחלוף 50 שנה של התיישבות,
            <br />
            הגיע הזמן לעלות קומה.
            <br />
            "נוער הגבעות" מושכים
            <br />
            את עם ישראל קדימה,
            <br />
            <span className={classes.boldText}>חזרה לארץ ישראל.</span>
          </h2>
        </div>
        <div className={classes.personImage}></div>
      </div>
    </div>
  );
};

export default Section3;
